module.exports = __webpack_public_path__ + "sunny_icon.png";